const GRID_COLS: Record<number, string> = {
  1: 'grid-cols-1',
  2: 'grid-cols-2',
  3: 'grid-cols-3',
  4: 'grid-cols-4',
};

export function getPageRowClassName(itemsPerPage: number) {
  return GRID_COLS[itemsPerPage] ?? 'grid-cols-1';
}

export function chunkItems<T>(items: T[], itemsPerPage: number): T[][] {
  if (itemsPerPage <= 0) {
    return [];
  }

  const pages: T[][] = [];

  for (let index = 0; index < items.length; index += itemsPerPage) {
    pages.push(items.slice(index, index + itemsPerPage));
  }

  return pages;
}
